/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Press_FortuneInputs */

const en_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const de_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const pt_br2_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const tr_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const zh_cn2_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const zh_hk2_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const ko_kr2_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const ru_ru2_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

const es_419_onboarding_v1_press_fortune = /** @type {(inputs: Onboarding_V1_Press_FortuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortune`)
};

/**
* | output |
* | --- |
* | "Fortune" |
*
* @param {Onboarding_V1_Press_FortuneInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_fortune = /** @type {((inputs?: Onboarding_V1_Press_FortuneInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_FortuneInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_fortune(inputs)
	if (locale === "de") return de_onboarding_v1_press_fortune(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_fortune(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_fortune(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_fortune(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_fortune(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_fortune(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_fortune(inputs)
	return es_419_onboarding_v1_press_fortune(inputs)
});